import applyInjection from './apply-injection';
import applyHook from './apply-hook';
import getExtensionControlsForElement from './get-extension-controls-for-element';

export default {
  applyInjection,
  applyHook,
  getExtensionControlsForElement,
};
